/**
 * Mission 1 "Attack the general": Opportunist (302) must attack or exhaust options before end turn / tutorial advance.
 */
export function opportunist302AllowsPassTurnDuringAttackGeneralStep(gameState, userId) {
  if (!gameState?.state || !userId) return false;
  const tn = gameState.turnNumber;
  const playerState = gameState.state[userId];
  const all = [...(playerState?.playedOrders?.front || []), ...(playerState?.playedOrders?.flank || [])];
  const opp = all.find((u) => u && Number(u.id) === 302);
  if (!opp) return false;
  if (opp.hasAttacked === true) return true;
  if (tn != null && opp.lastAttackTurn === tn) return true;
  const immobile = opp.immobilized === true || opp.isImmobilized === true || opp.status === 'immobilized';
  if (immobile) return true;
  const confused = opp.isConfused === true || opp.confused === true;
  const atk = Number(opp.attack ?? opp.attackRating);
  if (!Number.isNaN(atk) && atk <= 0 && !confused) return true;
  return false;
}
